export class ChessPiece {
    posX;
    posY;
    player;
    direction;
    isInitialPos;
    main; // default true for the king
    castle; // default true for the rock

    availablePositions() {
        return [];
    }

    positionsUnderAttack() {
        return [];
    }

    beforeMove(board, x, y) {
    }

    isCheckAfterMove(board, pos) {
        const boardClone = board.clone();
        const pieceClone = boardClone.getPiece(this.posX, this.posY);
        boardClone.movePieceWithoutHistory(pieceClone, pos[0], pos[1]);
        return boardClone.isCheck(this.player);
    }

    clone(piece) {
        piece.posX = this.posX;
        piece.posY = this.posY;
        piece.player = this.player;
        piece.main = this.main;
        piece.isInitialPos = this.isInitialPos;
        piece.castle = this.castle;
        if (this.direction) {
            piece.direction = [...this.direction];
        }
    }
}